<router-outlet></router-outlet>

<fb-version-renderer></fb-version-renderer>
